import { RestfulApiService } from './restful-api.service';
import { Partner } from '../model/mcp/partner';
import { PartnerMap } from '../model/mcp/partner-map';

class PartnerMapService extends RestfulApiService<PartnerMap, Partner> {
    protected getFormName(): string {
        return 'partner_map';
    }

    protected getPath(parent: Partner | undefined): string {
        if (!parent) {
            throw new Error('Parent is required for calls to PartnerMapService');
        }

        return `partners/${parent.id}/maps`;
    }
}

export const partnerMapService = new PartnerMapService();
